import React, { useState } from 'react'
import useSWR from 'swr'
import { getData } from '../sfc/component-helpers/requesthelpers'
import Votes from './Votes'
import chamberNames from '../../data/sfc/chamber_names.json'
import * as voteStyles from '../../styles/project-modules/bills/votes.module.less'
import {
  vote_dek
} from '../../data/LegisTracker_all_states_text.json'

function VoteSection({ bill, yourLegislators, MARKET_KEY }) {
  const { bill_id } = bill
  const market_key_filename = (MARKET_KEY === 'Houston' || MARKET_KEY === 'SanAntonio' || MARKET_KEY === 'Texcom') ? "TX" : MARKET_KEY
  const URL = `https://files.sfchronicle.com/legistracker/votes-${market_key_filename}-${bill_id}.json`

  let [upperVotes, setUpperVotes] = useState([])
  let [lowerVotes, setLowerVotes] = useState([])

  const { data: responseData, error } = useSWR(URL, getData, {
    onSuccess: (data) => {
      // console.log(data, 'data from vote request')
      let upper = []
      let lower = []
      //put into the correct list
      //only ever add one into the list, because that's the latest vote since
      // we sort by date on the backend
      data.forEach((vote) => {
        if (
          vote.roll_call_body_id === chamberNames[MARKET_KEY].upper_id &&
          upper.length == 0
        ) {
          upper.push(vote)
        } else if (
          vote.roll_call_body_id === chamberNames[MARKET_KEY].lower_id &&
          lower.length == 0
        ) {
          lower.push(vote)
        } else {
          // console.log('couldnt find chamber', vote)
        }
      })

      setUpperVotes(upper)
      setLowerVotes(lower)
    },
    onError: (err) => console.log(err, 'error from vote request'),
  })

  return (
    <div>
      <p className={voteStyles.text} dangerouslySetInnerHTML={{ __html: vote_dek }}>
      </p>
      {!upperVotes && !lowerVotes ? (
        <p className={voteStyles.text}>Loading latest votes...</p>
      ) : error ? (
        <p className={voteStyles.text}>
          Something went wrong loading the latest votes.
        </p>
      ) : (
        <>
          <h3 className={voteStyles.subhed}>{chamberNames[MARKET_KEY].sldl}</h3>
          {lowerVotes.length === 0 ? (
            <p className={voteStyles.exp}>
              The {chamberNames[MARKET_KEY].sldl} has not held a vote yet.
            </p>
          ) : (
            lowerVotes.map((vote) => (
              <Votes
                data={vote}
                chamber={'sldl'}
                yourLegislators={yourLegislators}
              />
            ))
          )}

          <h3 className={voteStyles.subhed}>{chamberNames[MARKET_KEY].sldu}</h3>
          {upperVotes.length === 0 ? (
            <p className={voteStyles.exp}>
              The {chamberNames[MARKET_KEY].sldu} has not held a vote yet.
            </p>
          ) : (
            upperVotes.map((vote) => (
              <Votes
                data={vote}
                chamber={'sldu'}
                yourLegislators={yourLegislators}
              />
            ))
          )}
        </>
      )}
    </div>
  )
}

export default VoteSection
